import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/33549057490?text=Bonjour,%20je%20souhaite%20des%20informations%20sur%20vos%20services%20de%20réparation.";

export const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="hidden md:flex fixed bottom-6 right-6 z-50 items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg transition-all hover:scale-110 whatsapp-pulse"
      aria-label="Contacter via WhatsApp"
      data-testid="whatsapp-floating-btn"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};
